module.exports = __webpack_public_path__ + "img/Poorter_hotel-223.5949d622.jpg";